import type { HTMLAttributes } from 'react'

import { initialsFromEmail } from './initials'

interface AvatarProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  email: string | null | undefined
  size?: 'md' | 'lg'
}

/**
 * Initials on the signal gradient.
 *
 * ALWAYS `aria-hidden`. The initials are a picture of an address the caller
 * already renders beside it — visibly, or visually hidden — so announcing "AL"
 * adds nothing and reads as a word. No email gives a disc with no letters:
 * nothing is invented to fill it.
 *
 * The ink is per-theme and the reason is measured in `components.css`; the
 * whole gradient is sampled by `src/styles/tokens.test.ts`, because axe cannot
 * see text on a gradient at all.
 */
export function Avatar({ email, size = 'md', className, ...rest }: AvatarProps) {
  const classes = [
    'avatar',
    size === 'lg' && 'avatar--lg',
    className,
  ].filter(Boolean).join(' ')

  return (
    <span {...rest} className={classes} aria-hidden="true">
      {initialsFromEmail(email)}
    </span>
  )
}
